// import React, { useRef } from 'react';
// import { motion, useScroll, useTransform } from 'framer-motion';

// const Word = ({ children, progress, range }) => {
//   const opacity = useTransform(progress, range, [0.3, 1]);
//   const color = useTransform(progress, range, ["hsla(221, 19%, 83%, 1.00)", "hsla(221, 19%, 83%, 1.00)"]);

//   return (
//     <motion.span style={{ opacity, color }} className="transition-colors duration-100 ease-in-out">
//       {children}{' '}
//     </motion.span>
//   );
// };

// const TextRevealOnScroll = ({ text, className, offset }) => {
//   const ref = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: offset || ["start 0.9", "end 0.25"]
//   });

//   const words = text.split(" ");

//   return (
//     <p
//       ref={ref}
//       className={`font-sans text-lg md:text-xl text-muted-foreground max-w-3xl mt-6 leading-relaxed ${className || ''}`}
//     >
//       {words.map((word, i) => {
//         const start = i / words.length;
//         const end = start + (1 / words.length);
//         return <Word key={i} progress={scrollYProgress} range={[start, end]}>{word}</Word>;
//       })}
//     </p>
//   );
// };

// export default TextRevealOnScroll;

import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const Word = ({ children, progress, range }) => {
  const opacity = useTransform(progress, range, [0.3, 1]);
  const color = useTransform(progress, range, ["hsl(220 15% 45%)", "hsl(220 40% 10%)"]);

  return (
    <motion.span style={{ opacity, color }} className="transition-colors duration-100 ease-in-out">
      {children}{' '}
    </motion.span>
  );
};

const TextRevealOnScroll = ({ text, className, offset }) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: offset || ["start 0.9", "end 0.25"]
  });

  const words = text.split(" ");

  return (
    <p
      ref={ref}
      className={`font-sans text-lg md:text-xl text-muted-foreground max-w-3xl mt-6 leading-relaxed ${className || ''}`}
    >
      {words.map((word, i) => {
        const start = i / words.length;
        const end = start + (1 / words.length);
        return <Word key={i} progress={scrollYProgress} range={[start, end]}>{word}</Word>;
      })}
    </p>
  );
};

export default TextRevealOnScroll;